import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Login from "./index";
import MpinLogin from "./MpinLogin";
import MpinSetup from "./MpinSetup";
import { Toaster } from "react-hot-toast";

type LoginFlow = 'phone' | 'mpin' | 'setup-mpin';

const LoginController: React.FC = () => {
  const [loginFlow, setLoginFlow] = useState<LoginFlow>('phone');
  const [pendingMpinSetup, setPendingMpinSetup] = useState<{phone: string, countryCode: string} | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already authenticated
    const authToken = localStorage.getItem("auth_token");
    if (authToken) {
      navigate("/leads", { replace: true });
    }
  }, [navigate]);

  const handleSwitchToMpin = () => {
    setLoginFlow('mpin');
  };

  const handleBackToPhone = () => {
    setLoginFlow('phone');
    setPendingMpinSetup(null);
  };

  const handleMpinNotSet = (phone: string, countryCode: string) => {
    // Store the phone details and redirect to OTP login, then MPIN setup
    setPendingMpinSetup({ phone, countryCode });
    localStorage.setItem("phone", phone);
    localStorage.setItem("countryCode", countryCode);
    // Navigate to OTP verification first, then MPIN setup will be shown after login
    navigate("/otp-verify");
  };

  const handleMpinSet = () => {
    setPendingMpinSetup(null);
    navigate("/leads", { replace: true });
  };

  const handleSkipMpin = () => {
    setPendingMpinSetup(null);
    navigate("/leads", { replace: true });
  };

  // If we're in setup mode (after successful OTP login)
  if (loginFlow === 'setup-mpin' || pendingMpinSetup) {
    return (
      <>
        <MpinSetup 
          onMpinSet={handleMpinSet}
          onSkip={handleSkipMpin}
        />
        <Toaster position="top-right" reverseOrder={false} />
      </>
    );
  }

  if (loginFlow === 'mpin') {
    return (
      <>
        <MpinLogin
          onBackToPhone={handleBackToPhone}
          onMpinNotSet={handleMpinNotSet}
        />
        <Toaster position="top-right" reverseOrder={false} />
      </>
    );
  }

  // Default phone login with MPIN option
  return (
    <>
      <Login onSwitchToMpin={handleSwitchToMpin} />
      <Toaster position="top-right" reverseOrder={false} />
    </>
  );
};

export default LoginController;